import { Link } from 'react-router-dom';
import { homepageFAQs } from '../data/faqData';

export default function SimpleFAQ() {
  return (
    <section className="py-6 sm:py-8 bg-white" aria-labelledby="home-faq-title">
      <div className="max-w-6xl mx-auto px-6">
        <details className="group border-y border-gray-200">
          <summary className="list-none cursor-pointer flex items-center justify-between gap-6 py-5 sm:py-6 min-h-[48px] [&::-webkit-details-marker]:hidden">
            <div>
              <h2 id="home-faq-title" className="text-xl sm:text-2xl font-semibold tracking-tight text-gray-900">You've got questions, we've got answers</h2>
              <p className="text-sm text-gray-600 mt-1">Everything you need to know about AI calling</p>
            </div>
            <span className="text-2xl text-[#8a6414] flex-shrink-0 group-open:hidden" aria-hidden="true">+</span>
            <span className="text-2xl text-[#8a6414] flex-shrink-0 hidden group-open:block" aria-hidden="true">−</span>
          </summary>
          <div className="border-t border-gray-200 pb-4">
            {homepageFAQs.map(faq => (
              <details key={faq.question} className="border-b border-gray-200 py-3 sm:py-4">
                <summary className="cursor-pointer text-base font-semibold text-gray-900 min-h-[44px] py-2 leading-relaxed">{faq.question}</summary>
                <p className="text-gray-600 leading-relaxed mt-2 max-w-3xl">{faq.answer}</p>
              </details>
            ))}
            <Link to="/faq" className="inline-flex min-h-[44px] items-center mt-3 text-[#806008] font-semibold hover:underline">See all questions →</Link>
          </div>
        </details>
      </div>
    </section>
  );
}
